"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var order_dto_1 = require("../../src/orders/order.dto");
var defenitions_1 = require("../../src/defenitions");
exports.anOrderResponse = function (overrides) {
    var address = {
        addressLine1: '123',
        addressLine2: '456',
        city: 'city',
        email: 'abc@wix.com',
        fullName: {
            lastName: 'John',
            firstName: 'Smith',
        },
        phone: '123465789',
        street: {
            name: 'abc',
            number: '123',
        },
        subdivision: 'US-NY',
        vatId: {
            number: '123',
            type: '1234',
        },
        zipCode: '123456',
        country: 'US',
        company: 'company',
    };
    var order = {
        id: '1111',
        buyerLanguage: 'en',
        cartId: '6c1e8c02-4608-4b23-aae9-1f414af7d686',
        channelInfo: {
            externalOrderId: '8f787727-1f24-43d7-b6fe-36005444857b',
            externalOrderUrl: 'https://moses.biz',
            type: "WEB" /* WEB */,
        },
        enteredBy: {
            id: 'ebb2bc1d-d4fc-45d8-9c56-211edc793c8e',
            identityType: order_dto_1.IdentityType.member,
        },
        inventoryItemId: 'aedf3886-59e6-40b7-b01f-785762c11f78',
        lastUpdated: new Date('02/10/1995').toISOString(),
        billingInfo: {
            externalTransactionId: '1',
            paidDate: new Date('05/25/2000').toISOString(),
            paymentMethod: 'paymentMethod',
            address: address,
            paymentGatewayTransactionId: '814167da-4aef-418b-a6e2-fa6d4d228874',
            paymentProviderTransactionId: 'fb870c91-3188-4c7f-b668-eae0f9103ccc',
        },
        buyerInfo: {
            id: 'id',
            email: 'email@wix.com',
            firstName: 'first name',
            identityType: 'identityType',
            lastName: 'last name',
            phone: 'phone',
            type: order_dto_1.BuyerInfoType.MEMBER,
        },
        invoiceInfo: {
            source: '111',
            id: '2222',
        },
        buyerNote: 'some text',
        dateCreated: new Date('05/25/2000').toISOString(),
        currency: 'USD',
        fulfillmentStatus: 'abc',
        archived: false,
        lineItems: [
            {
                customTextFields: [{ title: 'title', value: 'value' }],
                productId: '',
                lineItemType: '',
                mediaItem: {
                    mediaId: '25aea07a-8894-4e71-81c2-c726ac946d69',
                    altText: 'ea deserunt ut',
                    height: 50,
                    mediaType: defenitions_1.MediaItemType.image,
                    externalImageUrl: 'http://lorempixel.com/640/480',
                    url: 'http://static.wixstatic.com/media/289e7e_4d7e6ed33f324a0aa3e1821ee6142781~mv2.jpeg/v1/fill/w_50,h_50,al_c,q_90/file.jpg',
                    width: 50,
                },
                name: 'A great product',
                notes: 'nnnoootttess',
                options: [{ option: 'title', selection: 'value' }],
                price: '5',
                quantity: 1,
                sku: 'sssskkkkuuuu',
                totalPrice: '6',
                weight: '1.42',
                discount: '13.6',
                index: 2,
                tax: '58.2',
                taxGroupId: 'cbc5dd01-c7e1-4171-bbc8-125e9e27a773',
                taxIncludedInPrice: false,
                translatedName: 'translated name',
            },
        ],
        activities: [],
        number: '123456',
        paymentStatus: 'xyz',
        shippingInfo: {
            deliveryOption: 'abc',
            estimatedDeliveryTime: 'abc',
            pickupDetails: {
                buyerDetails: {
                    email: '',
                    fullName: {
                        firstName: '',
                        lastName: '',
                    },
                    phone: '',
                },
                pickupAddress: {
                    addressLine1: 'addressLine1',
                    city: 'city',
                    subdivision: 'subdivision',
                    zipCode: 'zipCode',
                    country: 'country',
                },
                pickupInstructions: 'abc efg',
            },
            shipmentDetails: {
                discount: '234.4',
                tax: '13.43',
                address: address,
                trackingInfo: {},
            },
            deliverUntil: 'Delivery today!',
        },
        totals: {
            discount: '0',
            quantity: 1,
            shipping: '2',
            subtotal: '3',
            tax: '0',
            total: '5',
            weight: '1',
        },
        weightUnit: 'kg',
        customField: {
            title: 'What is your additional info',
            translatedTitle: 'Quelle est votre information supplémentaire?',
            value: 'This is my additional info',
        },
        fulfillments: [
            {
                id: '8',
                dateCreated: new Date('04/21/2000').toISOString(),
                lineItems: [
                    {
                        index: 2,
                        quantity: 1,
                    },
                ],
                trackingInfo: {
                    trackingNumber: '45454545454',
                    shippingProvider: 'fedex',
                    trackingLink: 'https://www.fedex.com/apps/fedextrack/?action=track&trackingnumber=45454545454',
                },
            },
        ],
    };
    return { order: __assign(__assign({}, order), overrides) };
};
exports.anOrdersResponse = function (overrides) {
    return __assign({ orders: [], totalResults: 0 }, overrides);
};
//# sourceMappingURL=orders.js.map